export default __webpack_public_path__ + "2fbdac5e583961a6294b8148a6adf614.png";